import { render } from "./Timetable.vue?vue&type=template&id=a8d37526&scoped=true"
import script from "./Timetable.vue?vue&type=script&lang=js"
export * from "./Timetable.vue?vue&type=script&lang=js"

import "./Timetable.vue?vue&type=style&index=0&id=a8d37526&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d37526"]])

export default __exports__